/**
 * 🏗️ FSD Shared Layer - Activity Utils
 * 
 * ActivityPage에서 사용되는 아이콘 관련 유틸리티 함수들
 */ import React from 'react';
import { BookOpen, Code, Layout, Award, Check, GitCommit, Table, Brain, Lightbulb, FileCode, Terminal, Bug, GitBranch, TestTube, Zap, Shield, RefreshCw } from 'lucide-react';
/**
 * 학습 영역별 아이콘 반환
 */ export var getAreaIcon = function(area) {
    switch(area){
        // 전문 영역
        case '알고리즘':
            return /*#__PURE__*/ React.createElement(Code, {
                className: "h-5 w-5 text-blue-500"
            });
        case '프론트엔드':
            return /*#__PURE__*/ React.createElement(Layout, {
                className: "h-5 w-5 text-purple-500"
            });
        case '백엔드':
            return /*#__PURE__*/ React.createElement(GitCommit, {
                className: "h-5 w-5 text-green-500"
            });
        case '데이터베이스':
            return /*#__PURE__*/ React.createElement(Table, {
                className: "h-5 w-5 text-yellow-500"
            });
        case '컴퓨터 과학':
            return /*#__PURE__*/ React.createElement(Brain, {
                className: "h-5 w-5 text-pink-500"
            });
        case '소프트웨어 설계':
            return /*#__PURE__*/ React.createElement(Lightbulb, {
                className: "h-5 w-5 text-cyan-500"
            });
        // 코딩 기본기
        case '자료구조':
            return /*#__PURE__*/ React.createElement(FileCode, {
                className: "h-5 w-5 text-indigo-500"
            });
        case '코딩 스타일':
            return /*#__PURE__*/ React.createElement(Terminal, {
                className: "h-5 w-5 text-amber-500"
            });
        case '디버깅':
            return /*#__PURE__*/ React.createElement(Bug, {
                className: "h-5 w-5 text-red-500"
            });
        case '버전 관리':
            return /*#__PURE__*/ React.createElement(GitBranch, {
                className: "h-5 w-5 text-emerald-500"
            });
        case '테스트 작성':
            return /*#__PURE__*/ React.createElement(TestTube, {
                className: "h-5 w-5 text-fuchsia-500"
            });
        case '성능 최적화':
            return /*#__PURE__*/ React.createElement(Zap, {
                className: "h-5 w-5 text-orange-500"
            });
        case '보안':
            return /*#__PURE__*/ React.createElement(Shield, {
                className: "h-5 w-5 text-rose-500"
            });
        case '코드 리팩토링':
            return /*#__PURE__*/ React.createElement(RefreshCw, {
                className: "h-5 w-5 text-teal-500"
            });
        default:
            return /*#__PURE__*/ React.createElement(Code, {
                className: "h-5 w-5 text-gray-500"
            });
    }
};
/**
 * 활동 유형별 아이콘 반환
 */ export var getActivityTypeIcon = function(type) {
    switch(type){
        case '학습':
            return /*#__PURE__*/ React.createElement(BookOpen, {
                className: "h-5 w-5 text-blue-500"
            });
        case '문제 해결':
            return /*#__PURE__*/ React.createElement(Code, {
                className: "h-5 w-5 text-purple-500"
            });
        case '프로젝트':
            return /*#__PURE__*/ React.createElement(Layout, {
                className: "h-5 w-5 text-green-500"
            });
        case '챌린지':
            return /*#__PURE__*/ React.createElement(Award, {
                className: "h-5 w-5 text-orange-500"
            });
        case '테스트':
            return /*#__PURE__*/ React.createElement(Check, {
                className: "h-5 w-5 text-red-500"
            });
        case '토론':
            return /*#__PURE__*/ React.createElement(GitCommit, {
                className: "h-5 w-5 text-cyan-500"
            });
        default:
            return /*#__PURE__*/ React.createElement(BookOpen, {
                className: "h-5 w-5 text-gray-500"
            });
    }
};
